<template>
    <div class="a-youtube">
        <iframe
            class="a-youtube__iframe"
            type="text/html"
            :src="`https://www.youtube.com/embed/${youTubeId}`"
            frameborder="0"
        />
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true
        }
    },
    computed: {
        youTubeId() {
            return this.src.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/)[1]
        }
    }
}
</script>
